import RequestViewCard from "./RequestsViewCard"
import DocumentViewTable from "./RequestsViewTable"

const RequestsViews = ({
  documents,
  deletedDocumentIds,
  layoutOption,
  appliedTableSorting,
  users,
  onCancelRequest,
  onDownloadRequest,
  onSignRequest,
  onSortRequests,
}) => {
  const stripMetaKey = (value) => {
    try {
      return value.split("||")[0]
    } catch (error) {
      return value
    }
  }

  if (documents?.items?.length > 0) {
    if (layoutOption === "grid") {
      return (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {documents.items.map((request, index) => {
            return (
              <RequestViewCard
                request={request}
                deletedDocumentIds={deletedDocumentIds}
                stripMetaKey={stripMetaKey}
                users={users}
                onCancelRequest={onCancelRequest}
                onDownloadRequest={onDownloadRequest}
                onSignRequest={onSignRequest}
                key={index}
              />
            )
          })}
        </div>
      )
    } else {
      return (
        <DocumentViewTable
          documents={documents}
          deletedDocumentIds={deletedDocumentIds}
          stripMetaKey={stripMetaKey}
          appliedSorting={appliedTableSorting}
          users={users}
          onCancelRequest={onCancelRequest}
          onDownloadRequest={onDownloadRequest}
          onSignRequest={onSignRequest}
          onSortRequests={onSortRequests}
        />
      )
    }
  } else {
    return <>No requests found</>
  }
}
export default RequestsViews
